export default "__VITE_ASSET__7762a409__"